import script from "./Earth.vue?vue&type=script&lang=ts&setup=true"
export * from "./Earth.vue?vue&type=script&lang=ts&setup=true"

import "./Earth.vue?vue&type=style&index=0&id=26c2148c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c2148c"]])

export default __exports__